/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../models/fulfillment_type';
import '../../fedex_verification/models';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "fulfillment": {
                "nested": {
                  "preferences": {
                    "nested": {
                      "providers": {
                        "nested": {
                          "models": {
                            "nested": {
                              "FulfillmentProvider": {
                                "fields": {
                                  "id": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "merchantId": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "createdAt": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "updatedAt": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "fulfillmentTypes": {
                                    "type": ".squareup.connect.v2.fulfillment.models.FulfillmentType",
                                    "id": 5,
                                    "rule": "repeated"
                                  },
                                  "credentialId": {
                                    "type": "string",
                                    "id": 6,
                                    "rule": "optional"
                                  },
                                  "provider": {
                                    "type": ".squareup.connect.v2.fulfillment.preferences.providers.models.Provider",
                                    "id": 7,
                                    "rule": "optional"
                                  },
                                  "shippoProviderDetails": {
                                    "type": ".squareup.connect.v2.fulfillment.preferences.providers.models.ShippoProviderDetails",
                                    "id": 8,
                                    "rule": "optional"
                                  },
                                  "upsDapProviderDetails": {
                                    "type": ".squareup.connect.v2.fulfillment.preferences.providers.models.UpsDapProviderDetails",
                                    "id": 9,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "ShippoProviderDetails": {
                                "fields": {
                                  "carrierAccounts": {
                                    "type": ".squareup.connect.v2.fulfillment.preferences.providers.models.ShippoCarrierAccountDetails",
                                    "id": 1,
                                    "rule": "repeated"
                                  },
                                  "defaultCarrier": {
                                    "type": ".squareup.connect.v2.fulfillment.preferences.providers.models.Carrier",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "defaultCarrierServiceLevel": {
                                    "type": ".squareup.connect.v2.fulfillment.preferences.providers.models.CarrierServiceLevel",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "ShippoCarrierAccountDetails": {
                                "fields": {
                                  "carrier": {
                                    "type": ".squareup.connect.v2.fulfillment.preferences.providers.models.Carrier",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "accountId": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "isShippoMasterAccount": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "externalId": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "isActive": {
                                    "type": "bool",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "verificationStatus": {
                                    "type": ".squareup.connect.v2.fulfillment.preferences.fedex_verification.FedExVerificationStatus",
                                    "id": 6,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "UpsDapProviderDetails": {
                                "fields": {
                                  "accountDetails": {
                                    "type": ".squareup.connect.v2.fulfillment.preferences.providers.models.UpsDapProviderAccountDetails",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "defaultCarrierServiceLevel": {
                                    "type": ".squareup.connect.v2.fulfillment.preferences.providers.models.CarrierServiceLevel",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "isByoa": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "UpsDapProviderAccountDetails": {
                                "fields": {
                                  "accountNumber": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "Provider": {
                                "values": {
                                  "PROVIDER_DO_NOT_USE": 0,
                                  "SHIPPO": 1,
                                  "UPS_DAP": 2
                                }
                              },
                              "Carrier": {
                                "values": {
                                  "CARRIER_DO_NOT_USE": 0,
                                  "USPS": 1,
                                  "UPS": 2,
                                  "FEDEX": 3,
                                  "CANADA_POST": 4,
                                  "DHL_EXPRESS": 5
                                }
                              },
                              "CarrierServiceLevel": {
                                "values": {
                                  "CARRIER_SERVICE_LEVEL_DO_NOT_USE": 0,
                                  "USPS_PRIORITY": 10000,
                                  "USPS_PRIORITY_EXPRESS": 10001,
                                  "USPS_FIRST": 10002,
                                  "USPS_PARCEL_SELECT": 10003,
                                  "USPS_MEDIA_MAIL": 10004,
                                  "USPS_PRIORITY_MAIL_INTERNATIONAL": 10005,
                                  "USPS_PRIORITY_MAIL_EXPRESS_INTERNATIONAL": 10006,
                                  "USPS_FIRST_CLASS_PACKAGE_INTERNATIONAL_SERVICE": 10007,
                                  "USPS_GROUND_ADVANTAGE": 10008,
                                  "FEDEX_GROUND": 20000,
                                  "FEDEX_HOME_DELIVERY": 20001,
                                  "FEDEX_SMART_POST": 20002,
                                  "FEDEX_2_DAY": 20003,
                                  "FEDEX_2_DAY_AM": 20004,
                                  "FEDEX_EXPRESS_SAVER": 20005,
                                  "FEDEX_STANDARD_OVERNIGHT": 20006,
                                  "FEDEX_PRIORITY_OVERNIGHT": 20007,
                                  "FEDEX_FIRST_OVERNIGHT": 20008,
                                  "FEDEX_FREIGHT_PRIORITY": 20009,
                                  "FEDEX_NEXT_DAY_FREIGHT": 20010,
                                  "FEDEX_FREIGHT_ECONOMY": 20011,
                                  "FEDEX_FIRST_FREIGHT": 20012,
                                  "FEDEX_INTERNATIONAL_ECONOMY": 20013,
                                  "FEDEX_INTERNATIONAL_PRIORITY": 20014,
                                  "FEDEX_INTERNATIONAL_FIRST": 20015,
                                  "FEDEX_EUROPE_FIRST_INTERNATIONAL_PRIORITY": 20016,
                                  "FEDEX_INTERNATIONAL_CONNECT_PLUS": 20017,
                                  "FEDEX_INTERNATIONAL_ECONOMY_FREIGHT": 20018,
                                  "FEDEX_INTERNATIONAL_PRIORITY_EXPRESS": 20019,
                                  "FEDEX_INTERNATIONAL_PRIORITY_FREIGHT": 20020,
                                  "FEDEX_GROUND_ECONOMY": 20021,
                                  "FEDEX_FIRST": 20022,
                                  "FEDEX_PRIORITY": 20023,
                                  "FEDEX_PRIORITY_EXPRESS": 20024,
                                  "FEDEX_ECONOMY_SELECT": 20025,
                                  "FEDEX_REGIONAL_ECONOMY": 20026,
                                  "FEDEX_FIRST_OVERNIGHT_EXTRA_HOURS": 20027,
                                  "FEDEX_NEXT_DAY_MID_MORNING": 20028,
                                  "FEDEX_PRIORITY_OVERNIGHT_EXTRA_HOURS": 20029,
                                  "FEDEX_STANDARD_OVERNIGHT_EXTRA_HOURS": 20030,
                                  "FEDEX_ONE_DAY_FREIGHT": 20031,
                                  "UPS_STANDARD": 30000,
                                  "UPS_GROUND": 30001,
                                  "UPS_SAVER": 30002,
                                  "UPS_3_DAY_SELECT": 30003,
                                  "UPS_SECOND_DAY_AIR": 30004,
                                  "UPS_SECOND_DAY_AIR_AM": 30005,
                                  "UPS_NEXT_DAY_AIR": 30006,
                                  "UPS_NEXT_DAY_AIR_SAVER": 30007,
                                  "UPS_NEXT_DAY_AIR_EARLY_AM": 30008,
                                  "UPS_MAIL_INNOVATIONS_DOMESTIC": 30009,
                                  "UPS_SUREPOST": 30010,
                                  "UPS_SUREPOST_BOUND_PRINTED_MATTER": 30011,
                                  "UPS_SUREPOST_LIGHTWEIGHT": 30012,
                                  "UPS_SUREPOST_MEDIA": 30013,
                                  "UPS_EXPRESS": 30014,
                                  "UPS_EXPRESS_1200": 30015,
                                  "UPS_EXPRESS_PLUS": 30016,
                                  "UPS_EXPEDITED": 30017,
                                  "UPS_EXPRESS_EARLY": 30018,
                                  "UPS_ACCESS_POINT_ECONOMY": 30019,
                                  "UPS_MAIL_INNOVATIONS_BPM_FLAT": 30020,
                                  "UPS_MAIL_INNOVATIONS_BPM_PARCEL": 30021,
                                  "UPS_MAIL_INNOVATIONS_IRREGULAR": 30022,
                                  "UPS_MAIL_INNOVATIONS_MEDIA_MAIL": 30023,
                                  "UPS_MAIL_INNOVATIONS_PARCEL": 30024,
                                  "UPS_MAIL_INNOVATIONS_STANDARD_FLAT": 30025,
                                  "UPS_WORLDWIDE_ECONOMY_DDU": 30026,
                                  "UPS_WORLDWIDE_EXPRESS_FREIGHT_MIDDAY": 30027,
                                  "UPS_WORLDWIDE_ECONOMY_DDP": 30028,
                                  "UPS_WORLDWIDE_EXPRESS_FREIGHT": 30029,
                                  "UPS_MAIL_INNOVATIONS_FIRST_CLASS": 30030,
                                  "UPS_MAIL_INNOVATIONS_PRIORITY": 30031,
                                  "UPS_MAIL_INNOVATIONS_EXPEDITED": 30032,
                                  "UPS_MAIL_INNOVATIONS_PRIORITY_INTERNATIONAL": 30033,
                                  "UPS_MAIL_INNOVATIONS_ECONOMY_INTERNATIONAL": 30034,
                                  "UPS_MAIL_INNOVATIONS_RETURNS": 30035,
                                  "UPS_ROADIE_XD_AM": 30036,
                                  "UPS_ROADIE_XD_PM": 30037,
                                  "UPS_ROADIE_XD": 30038,
                                  "CANADA_POST_REGULAR_PARCEL": 40000,
                                  "CANADA_POST_EXPEDITED_PARCEL": 40001,
                                  "CANADA_POST_PRIORITY": 40002,
                                  "CANADA_POST_XPRESSPOST": 40003,
                                  "CANADA_POST_XPRESSPOST_INTERNATIONAL": 40004,
                                  "CANADA_POST_XPRESSPOST_USA": 40005,
                                  "CANADA_POST_EXPEDITED_PARCEL_USA": 40006,
                                  "CANADA_POST_TRACKED_PACKET_USA": 40007,
                                  "CANADA_POST_SMALL_PACKET_USA_AIR": 40008,
                                  "CANADA_POST_TRACKED_PACKET_INTERNATIONAL": 40009,
                                  "CANADA_POST_SMALL_PACKET_INTERNATIONAL_AIR": 40010,
                                  "CANADA_POST_SMALL_PACKET_INTERNATIONAL_SURFACE": 40011,
                                  "CANADA_POST_INTERNATIONAL_PARCEL_SURFACE": 40012,
                                  "CANADA_POST_INTERNATIONAL_PARCEL_AIR": 40013,
                                  "DHL_EXPRESS_DOMESTIC_EXPRESS_DOC": 50000,
                                  "DHL_EXPRESS_ECONOMY_SELECT_DOC": 50001,
                                  "DHL_EXPRESS_WORLDWIDE_NONDOC": 50002,
                                  "DHL_EXPRESS_WORLDWIDE_DOC": 50003,
                                  "DHL_EXPRESS_WORLDWIDE": 50004,
                                  "DHL_EXPRESS_WORLDWIDE_EU_DOC": 50005,
                                  "DHL_EXPRESS_BREAK_BULK_EXPRESS_DOC": 50006,
                                  "DHL_EXPRESS_EXPRESS_9_00_NONDOC": 50007,
                                  "DHL_EXPRESS_ECONOMY_SELECT_NONDOC": 50008,
                                  "DHL_EXPRESS_BREAK_BULK_ECONOMY_DOC": 50009,
                                  "DHL_EXPRESS_EXPRESS_9_00_DOC": 50010,
                                  "DHL_EXPRESS_EXPRESS_10_30_DOC": 50011,
                                  "DHL_EXPRESS_EXPRESS_10_30_NONDOC": 50012,
                                  "DHL_EXPRESS_EXPRESS_12_00_DOC": 50013,
                                  "DHL_EXPRESS_EUROPACK_NONDOC": 50014,
                                  "DHL_EXPRESS_EXPRESS_ENVELOPE_DOC": 50015,
                                  "DHL_EXPRESS_EXPRESS_12_00_NONDOC": 50016,
                                  "DHL_EXPRESS_EXPRESS_12_DOC": 50017,
                                  "DHL_EXPRESS_WORLDWIDE_B2C_DOC": 50018,
                                  "DHL_EXPRESS_WORLDWIDE_B2C_NONDOC": 50019,
                                  "DHL_EXPRESS_MEDICAL_EXPRESS": 50020,
                                  "DHL_EXPRESS_EXPRESS_EASY_NONDOC": 50021
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.fulfillment?.nested?.preferences?.nested?.providers?.nested?.models?.nested?.FulfillmentProvider && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.fulfillment?.nested?.preferences?.nested?.providers?.nested?.models?.nested?.ShippoProviderDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.fulfillment?.nested?.preferences?.nested?.providers?.nested?.models?.nested?.ShippoCarrierAccountDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.fulfillment?.nested?.preferences?.nested?.providers?.nested?.models?.nested?.UpsDapProviderDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.fulfillment?.nested?.preferences?.nested?.providers?.nested?.models?.nested?.UpsDapProviderAccountDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.fulfillment?.nested?.preferences?.nested?.providers?.nested?.models?.nested?.Provider && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.fulfillment?.nested?.preferences?.nested?.providers?.nested?.models?.nested?.Carrier && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.fulfillment?.nested?.preferences?.nested?.providers?.nested?.models?.nested?.CarrierServiceLevel) {
  $root.addJSON(jsonData);
}

/**
 * @desc Fulfillment providers store details about the connected platform integrations that provide sellers
 * with fulfillment service. They can be platform integrations, such as Shippo, or direct carrier integrations.
 * Fulfillment providers inform the shipment label purchase workflow about how to fetch fulfillment rates and buy
 * shipment labels.
 *
 * SOURCE FulfillmentProvider @ squareup/fulfillment/preferences/providers/models/fulfillment_provider.proto at 21:1
 */
export const FulfillmentProvider = $root.lookupType('squareup.connect.v2.fulfillment.preferences.providers.models.FulfillmentProvider');
fixType(FulfillmentProvider, {
  provider: {
    required: true
  }
});
Builder.createAndAttachToType(FulfillmentProvider);
/**
 * --
 * @desc The details of the linked shippo account.
 *
 * SOURCE ShippoProviderDetails @ squareup/fulfillment/preferences/providers/models/fulfillment_provider.proto at 86:1
 */
export const ShippoProviderDetails = $root.lookupType('squareup.connect.v2.fulfillment.preferences.providers.models.ShippoProviderDetails');
fixType(ShippoProviderDetails);
Builder.createAndAttachToType(ShippoProviderDetails);
/**
 * --
 * @desc The details of the shippo carrier account
 *
 * SOURCE ShippoCarrierAccountDetails @ squareup/fulfillment/preferences/providers/models/fulfillment_provider.proto at 97:1
 */
export const ShippoCarrierAccountDetails = $root.lookupType('squareup.connect.v2.fulfillment.preferences.providers.models.ShippoCarrierAccountDetails');
fixType(ShippoCarrierAccountDetails, {
  carrier: {
    required: true
  },
  accountId: {
    required: true
  },
  isShippoMasterAccount: {
    required: true
  },
  externalId: {
    required: true
  },
  isActive: {
    required: true
  }
});
Builder.createAndAttachToType(ShippoCarrierAccountDetails);
/**
 * --
 * @desc The details of the linked UPS DAP account.
 *
 * SOURCE UpsDapProviderDetails @ squareup/fulfillment/preferences/providers/models/fulfillment_provider.proto at 144:1
 */
export const UpsDapProviderDetails = $root.lookupType('squareup.connect.v2.fulfillment.preferences.providers.models.UpsDapProviderDetails');
fixType(UpsDapProviderDetails);
Builder.createAndAttachToType(UpsDapProviderDetails);
/**
 * SOURCE UpsDapProviderAccountDetails @ squareup/fulfillment/preferences/providers/models/fulfillment_provider.proto at 157:1
 */
export const UpsDapProviderAccountDetails = $root.lookupType('squareup.connect.v2.fulfillment.preferences.providers.models.UpsDapProviderAccountDetails');
fixType(UpsDapProviderAccountDetails, {
  accountNumber: {
    required: true
  }
});
Builder.createAndAttachToType(UpsDapProviderAccountDetails);
/**
 * --
 * @desc Supported providers list. Providers could be platforms such as Shippo, or, in the future,
 * direct carrier integrations.
 *
 * SOURCE Provider @ squareup/fulfillment/preferences/providers/models/fulfillment_provider.proto at 187:1
 */
export const Provider = $root.lookupEnum('squareup.connect.v2.fulfillment.preferences.providers.models.Provider').values;
/**
 * --
 * @desc End fulfillment carriers/logistics companies that provide fulfillment service. To enable a service, ensure that it has a service_level_name, a description, and is not marked as deprecated. To be used via shippo, a service requires a shippo_service_level_name. To be used via UPS (BYOA or DAP), a service must have a ups_service_code
 *
 * SOURCE Carrier @ squareup/fulfillment/preferences/providers/models/fulfillment_provider.proto at 212:1
 */
export const Carrier = $root.lookupEnum('squareup.connect.v2.fulfillment.preferences.providers.models.Carrier').values;
/**
 * SOURCE CarrierServiceLevel @ squareup/fulfillment/preferences/providers/models/fulfillment_provider.proto at 222:1
 */
export const CarrierServiceLevel = $root.lookupEnum('squareup.connect.v2.fulfillment.preferences.providers.models.CarrierServiceLevel').values;